<template>
<div id="h5">
  <iframe :src="url" style="height:100vh" frameborder="0" width="100%" height="100vh"></iframe>
</div>
</template>

<script>
export default {
  name: 'H5',
  data() {
    return {
      url: '',
      title: ''
    }
  },
  components: {

  },
  mounted() {

  },
  created() {
    this.$store.dispatch('share/initShareParams')
    switch (this.$route.query.title) {
      case '用户服务协议':
        {
          this.url = 'https://szone-activity.7net.cc/views/protocol/user_services_agreement.html?share=false'
          break
        }
      case '隐私政策':
        {
          this.url = 'https://szone-activity.7net.cc/views/protocol/privacy_policy.html?share=false'
          break
        }
    }
    document.title = this.$route.query.title
  }
}
</script>

<style>

</style>
